<template>
  <div v-if="estimate" class="d-lg-none d-block">
    <div>
      <div class="col-6 col-md-4 col-lg-4 mb-4">
        <div class="invoice-logo">
          <img
            v-if="estimate?.user?.setting"
            :src="estimate?.user?.setting?.business_logo"
            alt="logo"
          />
          <img v-else :src="settings?.business_logo" alt="logo" />
        </div>
      </div>
      <div class="col-4 col-md-4 col-lg-4 mt-2">
        <h1 class="invoice_mb-head mb-1">
          {{ estimate?.estimate_id }}
        </h1>
        <p class="total-inner-p">
          {{ estimate?.description }}
        </p>
      </div>
    </div>

    <div class="py-3 my-3 border border-start-0 border-end-0">
      <div class="invoice_mb-to">
        <p class="invoice-details-two text-start">
          Status:
          <span
            class="invoice-status text-success"
            v-if="estimate.status === 'sent' || estimate.status === 'refunded'"
            >{{ estimate.status }}</span
          >
          <span
            class="invoice-status text-warning"
            v-else-if="estimate.status === 'draft'"
            >{{ estimate.status }}</span
          >
          <span
            class="invoice-status text-danger"
            v-else-if="
							estimate.status === 'expired' || estimate.status === 'rejected'
						"
            >{{ estimate.status }}</span
          >
        </p>
        <p class="invoice-details-two text-start">
          Date:
          <strong v-if="estimate.date">{{
						formatDateToDigits(estimate?.date)
          }}</strong>
        </p>
        <p class="invoice-details-two text-start">
          Due on:
          <strong v-if="estimate.due_date">{{
						formatDateToDigits(estimate?.due_date)
          }}</strong>
        </p>
        <p class="invoice-details-two text-start">
          Amount:
          <strong
            >{{ estimate?.currency?.slice(0, 3) }}
            {{ addCurrencyComma(estimate?.total_amount) }}</strong
          >
        </p>
      </div>
      <div v-if="estimate?.user" class="invoice_mb-to my-4">
        <p class="customer_mb-text-one text-start">Estimate From:</p>
        <p class="invoice-details-two">
          {{ estimate?.user?.name }}
        </p>
        <p class="invoice-details-two">
          {{ estimate?.user?.email }}
        </p>
        <p class="invoice-details-two">
          {{ `${estimate?.customer?.country_code} ${estimate?.customer?.phone}` }}
        </p>
        <p class="invoice-details-two">
          {{ estimate?.user?.address }}
        </p>
        <p class="invoice-details-two">
          {{ estimate?.user?.state }} {{ estimate?.user?.country }}
        </p>
      </div>
      <div v-else class="invoice_mb-to my-4">
        <p class="customer_mb-text-one text-start">Estimate From:</p>
        <p class="invoice-details-two">
          {{ user?.name }}
        </p>
        <p class="invoice-details-two">
          {{ user?.email }}
        </p>
        <p class="invoice-details-two">
          {{ user?.phone }}
        </p>
        <p class="invoice-details-two">
          {{ user?.address }}
        </p>
        <p class="invoice-details-two">{{ user?.state }} {{ user?.country }}</p>
      </div>
      <div class="invoice_mb-to">
        <p class="customer_mb-text-one">Estimate To:</p>
        <p class="invoice-details-two">
          {{ estimate?.customer?.name }}<br />
          {{ estimate?.customer?.email }}<br />
          {{ estimate?.customer?.phone }}<br />
          {{ estimate?.customer?.address }}<br />

          {{ estimate?.customer?.state }} {{ estimate?.customer?.country }}
        </p>
      </div>
    </div>

    <div class="card-body m-0">
      <!-- Invoice Item -->
      <div class="invoice-item">
        <div class="row">
          <div class="col-md-12">
            <div class="table-responsive2">
              <table class="table table-center table-hover mb-0">
                <thead class="thead-light">
                  <tr>
                    <th class="table-data">#</th>
                    <th class="table-data">Product / Service</th>
                    <th class="table-data">Quantity</th>
                    <th class="table-data">Price</th>
                    <th class="table-data">Discount</th>
                    <th class="text-end table-data">Amount</th>
                  </tr>
                </thead>
                <tbody v-if="estimate.items">
                  <tr v-for="(item, index) in estimate.items" :key="index">
                    <td class="table-data">
                      {{ index + 1 }}
                    </td>
                    <td class="table-data">{{ item.name }}</td>
                    <td class="table-data">
                      {{ item.quantity }}
                    </td>
                    <td class="table-data">
                      {{ estimate?.currency?.slice(0, 3) }}
                      {{ addCurrencyComma(item.price) }}
                    </td>
                    <td class="table-data">{{ item.discount }}%</td>
                    <td class="text-end table-data">
                      {{ estimate?.currency?.slice(0, 3) }}
                      {{ addCurrencyComma(item.amount) }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <!-- /Invoice Item -->
    </div>

    <!-- Terms & Conditions -->
    <div class="row justify-content-end my-3">
      <div>
        <div class="invoice-total-card">
          <div class="invoice-total-box">
            <div class="invoice-total-inner">
              <p class="total-inner-p">
                Taxable Amount
                <span
                  >{{ estimate?.currency?.slice(0, 3) }}
                  {{ addCurrencyComma(estimate?.amount) }}</span
                >
              </p>
              <p class="total-inner-p">
                Discount<span
                  >{{ estimate?.currency?.slice(0, 3) }}
                  {{ addCurrencyComma(totalProductDiscount) }}</span
                >
              </p>
              <p v-if="estimate?.tax_enabled === 1">
                {{ `VAT(${estimate.tax_percentage}%)` }}
                <span
                  >{{ estimate?.currency?.slice(0, 3) }}
                  {{ addCurrencyComma(vat) }}</span
                >
              </p>
              <p
                class="total-inner-p"
                v-for="(discount, index) in estimate?.more_discount"
                :key="index"
              >
                {{ discount.description }}
                <span
                  >- {{ estimate?.currency?.slice(0, 3) }}
                  {{ addCurrencyComma(discount.value) }}</span
                >
              </p>
              <p
                class="total-inner-p"
                v-for="(charge, index) in estimate?.additional_charges"
                :key="index"
              >
                {{ charge.description }}
                <span
                  >+ {{ estimate?.currency?.slice(0, 3) }}
                  {{ addCurrencyComma(charge.value) }}
                </span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Total -->
    <div class="border border-start-0 border-end-0 py-3">
      <div style="display: flex; justify-content: space-between">
        <div style="width: 47.8%">
          <div class="invoice-total-card">
            <div class="invoice-total-box">
              <div class="invoice-total-footer">
                <h4 class="total-amount" style="font-size: 20px">
                  Total Amount
                </h4>
              </div>
            </div>
          </div>
        </div>
        <div class="invoice-total-box">
          <div class="invoice-total-footer" style="margin-top: 0">
            <h4 class="total-amount" style="font-size: 20px; margin-top: 0">
              {{ estimate?.currency?.slice(0, 3) }}
              {{ addCurrencyComma(estimate?.total_amount) }}
            </h4>
          </div>
        </div>
      </div>
      <div>
        <p class="total-inner-p">
          Total Items :
          {{ estimate?.items?.length }}
        </p>
      </div>
    </div>

    <!-- Total -->
    <div style="display: flex; justify-content: start" class="my-3">
      <p class="total-inner-p">
        Total Amount (in words):
        <span
          style="margin-left: 2px; color: black; text-transform: capitalize"
          v-if="estimate?.total_amount"
        >
          {{ amountToWords(estimate?.total_amount, estimate?.currency) }}</span
        >
      </p>
    </div>

    <!-- Note -->
    <div class="total-amount py-3">
      <div>
        <div>
          <div class="text-start">
            <p class="bank-title total-amount">Notes</p>
            <div class="total-inner-e" v-html="estimate.notes"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {
	addCurrencyComma,
	amountToWords,
} from "@/assets/composables/currency";
import { formatDateToDigits } from "@/assets/composables/date";

const props = defineProps({
	estimate: {
		type: Object,
	},
	user: {
		type: Object,
	},
	settings: {
		type: Object,
	},
	totalAmount: {
		type: Number,
	},
	taxableAmount: {
		type: Number,
	},
	totalProductDiscount: {
		type: Number,
	},
	vat: {
		type: Number,
	},
	tax_percentage: {
		type: Number,
	},
});
</script>

<style>
@media (max-width: 960px) {
	.d-invoice {
		display: none;
	}
}
.invoice_mb-head {
	font-size: 18px;
}
.customer_mb-text-one {
	color: #95979b;
	display: block;
	margin: 0 0 8px;
}
.invoice_mb-to .invoice-details-two {
	text-align: left;
	font-size: 14px;
	color: #2c3038;
}
</style>
